module.exports = __webpack_public_path__ + "static/img/full.520bcafa.svg";